import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useBooleanState } from '../../hooks';

const LoadSrcBefore = ({ src, children }) => {
  const [imageSet, , setTrueImage] = useBooleanState(false);
  useEffect(() => {
    // eslint-disable-next-line no-undef
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setTrueImage();
    };
  }, [setTrueImage, src]);
  if (!imageSet) return null;
  return children;
};

LoadSrcBefore.propTypes = {
  src: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

export default LoadSrcBefore;
